<template>
    <div class="box">
        <div class="box2">
            <div class="selectReason line_bottom" @click="goSheet">
                 <div class="left">缘由</div>
                 <div class="right">
                       <p v-if="!selectBnt" style="color:#aaa">请选择 ></p>
                       <p v-else>{{selectBnt}}</p>
                 </div>
            </div>
            <div class="remark">
                <div class="titleName">补充</div>
                <div class="notAccepted">
                    <van-field
                    placeholder="请输入不予受理内容..."
                    type="textarea"
                    maxlength="2000"
                    v-model="remark"
                        />
                </div>
            </div>
            <div class="btn">
                <div class="submit">
                    <van-button type="primary" @click="submitBtn">提交</van-button>
                </div>
                <div class="back">
                    <van-button plain type="default" color="#979595" @click="goBack">返回</van-button>
                </div>
            </div>
        </div>
        <van-action-sheet v-model="isShow" :actions="actions" @select="onSelect"></van-action-sheet>
    </div>
</template>
<script>
    import api from '../../../../service/modules/complaintApis';
    import util from '../../../../utils/common'
    export default {
        components: {
        },
        data () {
            return {
                isShow: false,
                actions: [
                    { name: '投诉对象或事发地不在云南省行政区域内' },
                    { name: '有关行政管理部门、仲裁机构、法院已受理、处理的' },
                    { name: '涉及国家秘密、商业秘密、个人隐私的' },
                    { name: '法律、法规明确规定不予受理情形的' }
                ],
                organization: '',
                selectBnt: '',
                remark: '', // 备注
                item: util.getJsonLocal('item'),
                flag: false
                // isShowBtn: false
            }
        },
        created () {           
        },
        methods: {
            onSelect (item) {
                this.isShow = false;
                this.selectBnt = item.name;
            },
            goSheet () {
                this.isShow = true;
            },
            submitBtn () {
                // this.isShowBtn = true;
                console.log(this.$store.state.complaint.userInfo)
                if (this.remark.trim().length === 0) {
                    this.$Toast('不予受理内容不能为空');
                    return;
                }else if(this.selectBnt==''){
                    this.$Toast('请选择缘由');
                    return;
                }else{
                    let params = {
                        mainComplainNumber: this.item.mainComplainNumber, // 投诉主单号
                        reason: this.selectBnt, // 不予受理原因
                        complainNumber: this.item.complainNumber, // 投诉子单号
                        subId: this.item.subId, // 拆单表主键
                        subPid: this.item.subPid, // 拆单表父主键
                        content: this.remark // 不予受理内容
                    }
                    if (this.flag === false) {
                        this.flag = true;
                        api.worker.unAccept(params).then(res => {
                            if (res.ret === 0) {
                                // this.isShowBtn = false;
                                this.$Toast('操作成功');
                                this.$router.back();
                            }
                        })
                    }
                }
                
            },
            goBack () {
                this.$router.go(-1)
            }
        }
    }
</script>
<style lang="less" scoped>
.box {
    width: 100%;
    padding: 14px;
    background-color: #f4f3f3;
    box-sizing: border-box;
    height: 100%;
    .box2 {
        width: 100%;
        padding: 14px;
        background-color: #fff;
        font-size: 14px;
        box-sizing: border-box;
        .complaintInformation {
            width: 100%;
            .complaintNumber,.receivingAgency,.acceptedLaborNumber,.inadmissibleReason {
                display: flex;
                height: 50px;
                line-height: 50px;
                .left {
                    float: left;
                    width: 50%;
                    text-align: left;
                    color: #aaa
                }
                .right {
                    float: left;
                    width: 50%;
                    text-align: right;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                }
            }
            .border_bottom {
                border-bottom: 1px solid #eee
            }
            .complaintNumber {
                .right {
                    color: blue;
                }
            }
            .inadmissibleReason {
                .right {
                    color: #ddd;
                }
            }
        }
        .remark {
            width: 100%;
            padding: 12px 0 0 0;
            .titleName {
                color: #aaa;
                text-align: left;
            }
            .notAccepted {
                margin-top: 14px;
                .van-field {
                    height: 800px;
                }
                .van-cell {
                    font-size: 12px;
                    background: #efeded;
                    border-radius: 7px;
                }
            }
        }
        .btn {
            margin-top: 30px;
            .van-button {
                width: 100%;
                border-radius: 7px;
                margin-top: 10px;
            }
            .back {
                .van-button {
                    color: #bdb8b8
                }
                .van-button--plain {
                    background-color: #efeded;
                }
            }
        }
        .selectReason{
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 50px;
            line-height: 50px;
            .left{
                width:35%;
                color: #aaa;
            }
            .right{
                width:65%;
                overflow: hidden;
                p{
                    width:100%;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    text-align: right;
                }

            }
        }
    }
}
</style>
